export default __webpack_public_path__ + "static/media/login.b82fccf4.jpg";